/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SubjectOfferLastExamConvocation model module.
 * @module model/SubjectOfferLastExamConvocation
 * @version 1.0
 */
class SubjectOfferLastExamConvocation {
    /**
     * Constructs a new <code>SubjectOfferLastExamConvocation</code>.
     * @alias module:model/SubjectOfferLastExamConvocation
     */
    constructor() { 
        
        SubjectOfferLastExamConvocation.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubjectOfferLastExamConvocation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubjectOfferLastExamConvocation} obj Optional instance to populate.
     * @return {module:model/SubjectOfferLastExamConvocation} The populated <code>SubjectOfferLastExamConvocation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubjectOfferLastExamConvocation();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('academic_section_title')) {
                obj['academic_section_title'] = ApiClient.convertToType(data['academic_section_title'], 'String');
            }
            if (data.hasOwnProperty('exam_convocation_type')) {
                obj['exam_convocation_type'] = ApiClient.convertToType(data['exam_convocation_type'], 'Number');
            }
            if (data.hasOwnProperty('exam_convocation_type_title')) {
                obj['exam_convocation_type_title'] = ApiClient.convertToType(data['exam_convocation_type_title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
SubjectOfferLastExamConvocation.prototype['id'] = undefined;

/**
 * @member {String} academic_section_title
 */
SubjectOfferLastExamConvocation.prototype['academic_section_title'] = undefined;

/**
 * @member {Number} exam_convocation_type
 */
SubjectOfferLastExamConvocation.prototype['exam_convocation_type'] = undefined;

/**
 * @member {String} exam_convocation_type_title
 */
SubjectOfferLastExamConvocation.prototype['exam_convocation_type_title'] = undefined;






export default SubjectOfferLastExamConvocation;

